import type { DocumentVariable } from '../types/documentTemplates.types';

export interface VariableGroup {
  namespace: string;
  variables: DocumentVariable[];
}

export function groupVariablesByNamespace(variables: DocumentVariable[]): VariableGroup[] {
  const groups = new Map<string, DocumentVariable[]>();
  for (const variable of variables) {
    groups.set(variable.namespace, [...(groups.get(variable.namespace) ?? []), variable]);
  }
  return [...groups].map(([namespace, items]) => ({ namespace, variables: items }));
}

export function filterVariables(variables: DocumentVariable[], term: string): DocumentVariable[] {
  const needle = term.trim().toLowerCase();
  if (!needle) return variables;
  return variables.filter((variable) =>
    [variable.label, variable.key, variable.namespace].some((field) => field.toLowerCase().includes(needle)),
  );
}
